import {
    FETCH_FEATURED_MATCHES,
    FETCH_FEATURED_MATCHES_SUCCESS,
    FETCH_FEATURED_MATCHES_FAILURE,
    FETCH_FEATURED_MATCH,
    FETCH_FEATURED_MATCH_SUCCESS,
    FETCH_FEATURED_MATCH_FAILURE,
} from '../actions/featured-matches-actions';

function updateMatch(array, index, updatedMatch) {
    const newArray = array?.slice();
    const match = newArray[index];
    newArray[index] = {
        ...match,
        ...updatedMatch,
    };
    return newArray;
}

const initialState = {
    isLoading: false,
    error: null,
    matches: [],
    tournamentDetails: {},
    heroImageDetails: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FEATURED_MATCHES:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_FEATURED_MATCHES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                matches: action.data,
            };
        case FETCH_FEATURED_MATCHES_FAILURE:
            return {
                ...state,
                isLoading: false,
                matches: [],
                error: action.data || 'An error occured',
            };
        case FETCH_FEATURED_MATCH:
            return {
                ...state,
                matches: updateMatch(state.matches, action.index, { isLoading: true }),
            };
        case FETCH_FEATURED_MATCH_SUCCESS:
            return {
                ...state,
                matches: updateMatch(state.matches, action.index, { isLoading: false, data: action.data }),
            };
        case FETCH_FEATURED_MATCH_FAILURE:
            return {
                ...state,
                matches: updateMatch(state.matches, action.index, { isLoading: false, data: null, error: action.data || 'An error occured' }),
            };
        case 'TOURNAMENT_CONTENT:FETCH_TOURNAMENT_DETAIL_SUCCESS':
            return {
                ...state,
                tournamentDetails: action.data,
            };
        case 'TOURNAMENT_CONTENT:FETCH_HERO_IMAGE_DETAILS_REQUEST_SUCCESS':
            return {
                ...state,
                heroImageDetails: action.data,
            };
        default:
            return state;
    }
};
